export default "__VITE_ASSET__B6UtBIQ0__"